export const GET_CONSTANT_LIST_REQUEST = "GET_CONSTANT_LIST_REQUEST";
export const GET_CONSTANT_LIST_SUCCESS = "GET_CONSTANT_LIST_SUCCESS";
export const GET_CONSTANT_LIST_ERROR = "GET_CONSTANT_LIST_ERROR";
export const GET_LAST_SYNC_REQUEST = "GET_LAST_SYNC_REQUEST";
export const GET_LAST_SYNC_SUCCESS = "GET_LAST_SYNC_SUCCESS";
export const GET_LAST_SYNC_ERROR = "GET_LAST_SYNC_ERROR";
export const SYNC_REQUEST = "SYNC_REQUEST";
export const SYNC_SUCCESS = "SYNC_SUCCESS";
export const SYNC_ERROR = "SYNC_ERROR";